/**
 * Check if argument is defined.
 */
var defined = function defined(x) {
  return typeof x !== 'undefined';
};

export default defined;